// @flow

import React from 'react';
import { Theme } from 'operation-diameter';
import Header from './Header';
import Footer from './Footer';

import styles from './Layout.module.scss';

type Props = {
  children: React.Node
};

const Layout = ({ children }: Props) => {
  return (
    <Theme additionalClassnames={styles.fullPage}>
      <Header />
      <div className={styles.content}>{children}</div>
      <Footer isTrustPilotVisible={false} />
    </Theme>
  );
};

export default Layout;
